import type { ControlProps } from './types';

export function EnumControl({ schema, value, disabled, onChange }: ControlProps) {
  const options = schema.validation?.options ?? [];
  return (
    <select
      aria-label={schema.label}
      value={typeof value === 'string' ? value : ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      {!options.includes(String(value)) && <option value="">{String(value)}</option>}
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}
